/**
 * The instruction files an agent reads by itself in a repository (docs/refactor/50) — no app sends them: Claude Code
 * reads CLAUDE.md, Codex AGENTS.md, Gemini GEMINI.md, Kiro and Cursor their rule folders. "Antes de cada comando"
 * lists them, so what steers the agent is said, not guessed.
 */

const AT_THE_ROOT = ['CLAUDE.md', 'CLAUDE.local.md', 'AGENTS.md', 'GEMINI.md', '.claude/CLAUDE.md', '.github/copilot-instructions.md', '.cursorrules', '.windsurfrules']
const FOLDERS = ['.kiro/steering/', '.cursor/rules/', '.github/instructions/', '.windsurf/rules/']

/** At most this many: a repository with a hundred rules still shows a list one can read. */
export const MAX_INSTRUCTION_FILES = 40

/** Of a repository's files (as git lists them, forward slashes), the ones an agent reads as instructions. */
export function instructionFiles(files: string[]): string[] {
  const root = new Set(AT_THE_ROOT.map((f) => f.toLowerCase()))
  return files
    .map((f) => f.replace(/\\/g, '/'))
    .filter((f) => root.has(f.toLowerCase()) || FOLDERS.some((dir) => f.toLowerCase().startsWith(dir) && !f.endsWith('/')))
    .sort((a, b) => Number(a.includes('/')) - Number(b.includes('/')) || a.localeCompare(b))
    .slice(0, MAX_INSTRUCTION_FILES)
}
